import React, { useEffect } from "react"
import { FormattedMessage } from "react-intl"
import { connect, ConnectedProps } from "react-redux"
import Icon from "../../common/icon/icon.component"
import { getPriceList } from "../../state/price-list/priceListSelectors"
import OrderAttemptListingComponent from "../components/OrderAttemptListingComponent"
import { fetchOrderAttempts } from "../../state/price-list/orderAttemptActions"
import { getFailedOrderAttempts } from "../../state/price-list/orderAttemptSelectors"


const ORDER_ATTEMPT_FETCH_ACTION = "order-attempt-fetch-action"
type OwnProps = {
    priceListId: string
}
const OrderAttemptSection = (props: Props) => {
    if (!props.priceList) return <></>

    const { priceList, orderAttempts } = props
    useEffect(() => void props.fetchOrderAttempts(priceList.getId(), ORDER_ATTEMPT_FETCH_ACTION), [])

    if (orderAttempts.length == 0) return <></>
    return (
        <>
            <h4 className="m-0 p-0">
                <Icon value={"exclamation"} className={"mr-2"} />
                <FormattedMessage
                    id="price_list.analytics.order_attempts_label"
                    defaultMessage="Order Attempts"
                />
            </h4>

            <OrderAttemptListingComponent
                priceListId={props.priceListId}
                orderAttempts={orderAttempts}
            />
        </>
    )
}

const mapState = (state, props: OwnProps) => {
    return {
        ...props,
        priceList: getPriceList(state, props.priceListId),
        orderAttempts: getFailedOrderAttempts(state, props.priceListId),
    }
}
const mapDispatch = {
    fetchOrderAttempts,
}
const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(OrderAttemptSection)


// WEBPACK FOOTER //
// ./src/price-list/sections/OrderAttemptSection.tsx